import { createContext, useContext, useEffect } from "react";

/**
 * Allows modal content to register description content with the Modal shell.
 * Renders under the title (h2) in the header.
 */
export const ModalDescriptionContext = createContext(null);

/**
 * Set the modal description. Shown under the title in the header.
 * Clears on unmount.
 * @param {React.ReactNode} description - Description content (e.g. Beta badge)
 * @param {Array} deps - Optional dependency array
 */
export function useModalDescription(description, deps = []) {
  const value = useContext(ModalDescriptionContext);
  const setDescription = value?.[1];
  useEffect(() => {
    if (setDescription) setDescription(description ?? null);
    return () => {
      if (setDescription) setDescription(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps intentionally control when to push latest
  }, [setDescription, ...deps]);
}
